import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function PrivacyResidencyLawsIcon(props: IconProps) {
  return (
    <Icon width="72px" height="73" viewBox="0 0 72 73" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="36" cy="36.8066" r="35.4" fill="white" stroke="white" strokeWidth="1.2" />
      <path d="M25 23.8809L33.3613 23.8809" stroke="#00584F" strokeWidth="1.2" />
      <line x1="25" y1="30.6168" x2="41.0972" y2="30.6168" stroke="#00584F" strokeWidth="1.2" />
      <line x1="25" y1="35.3844" x2="41.0972" y2="35.3844" stroke="#00584F" strokeWidth="1.2" />
      <line x1="25" y1="40.1539" x2="41.0972" y2="40.1539" stroke="#00584F" strokeWidth="1.2" />
      <rect x="20" y="17.8066" width="32" height="38" rx="4" stroke="#00584F" strokeWidth="1.2" />
      <path
        d="M46.6602 37.4066H57.0004C57.7736 37.4066 58.4004 38.0334 58.4004 38.8066L58.4004 47.1339C58.4004 47.5975 58.1709 48.0311 57.7874 48.2917L52.6173 51.806C52.1423 52.1289 51.5183 52.1289 51.0433 51.806L45.8731 48.2917C45.4897 48.0311 45.2602 47.5975 45.2602 47.1339L45.2602 38.8066C45.2602 38.0334 45.887 37.4066 46.6602 37.4066Z"
        fill="#40E398"
        stroke="#00584F"
        strokeWidth="1.2"
      />
      <path d="M48.5718 43.8421L51.2487 45.8942L55.0886 41.8848" stroke="#00584F" strokeWidth="1.2" />
    </Icon>
  );
}
